._container_if6rm_1 {
  color: var(--text-color);
  white-space: pre-wrap; }
  ._container_if6rm_1 p {
    -webkit-margin-after: 0px !important;
            margin-block-end: 0px !important;
    -webkit-margin-before: 0px !important;
            margin-block-start: 0px !important; }

@container chat (max-width: 470px) {
  ._container_if6rm_1 p {
    font-size: var(--text-font-size-slim) !important;
    line-height: var(--text-line-height-slim) !important; } }
  ._container_if6rm_1 strong {
    font-weight: 600 !important; }

@container chat (max-width: 470px) {
  ._container_if6rm_1 span {
    font-size: var(--text-font-size-slim) !important;
    line-height: var(--text-line-height-slim) !important; } }
  ._container_if6rm_1 ol,
  ._container_if6rm_1 ul,
  ._container_if6rm_1 li {
    margin: 0 !important;
    padding: 0 !important;
    list-style-type: unset !important; }
    ._container_if6rm_1 ol::before, ._container_if6rm_1 ol::after,
    ._container_if6rm_1 ul::before,
    ._container_if6rm_1 ul::after,
    ._container_if6rm_1 li::before,
    ._container_if6rm_1 li::after {
      display: none !important; }
  ._container_if6rm_1 ul,
  ._container_if6rm_1 ol {
    margin-left: 13px !important; }
